import React from "react";
import "./Navbar.css"

const UpperNavbar = () => {
  return (
   <div id="upperNavbar">Get Rs.300 OFF on minimum spend of Rs.999.</div>
  )
};

export default UpperNavbar;
